// client/src/components/InteractiveContent.jsx
// Dibuja un mensaje interactivo (header media + cuerpo + pie + botones o lista)
// tal como lo recibió el usuario. Se usa tanto en el hilo del agente como en el
// visor del administrador. `interactive` puede llegar como objeto (desde Redis)
// o como string JSON (desde la base de datos), por eso lo normaliza.
import { theme } from '../theme';

function parse(interactive) {
  if (!interactive) return null;
  if (typeof interactive === 'string') {
    try { return JSON.parse(interactive); } catch { return null; }
  }
  return interactive;
}

export default function InteractiveContent({ interactive, body, dark }) {
  const cfg = parse(interactive);
  const text = body != null ? body : cfg?.body;
  const header = cfg?.header;
  const footer = cfg?.footer;
  const action = cfg?.action || {};

  // En burbujas del cliente (fondo claro) el texto de detalle debe verse; usamos
  // colores translúcidos que funcionan sobre fondo claro u oscuro.
  const muted = dark ? 'rgba(0,0,0,0.55)' : theme.colors.textMuted;
  const line = dark ? 'rgba(0,0,0,0.18)' : theme.colors.border;
  const btnText = dark ? '#0b3d55' : theme.colors.primary;

  const btnBox = {
    display: 'block', width: '100%', textAlign: 'center', boxSizing: 'border-box',
    border: `1px solid ${line}`, borderRadius: 8, padding: '7px 10px', marginTop: 6,
    fontSize: '0.82rem', fontWeight: 600, color: btnText, background: dark ? 'rgba(255,255,255,0.35)' : 'transparent',
  };

  return (
    <div>
      {/* Header media */}
      {header && header.url && (
        <div style={{ marginBottom: 6 }}>
          {header.type === 'image' && (
            <img src={header.url} alt="" style={{ maxWidth: '100%', borderRadius: 8, display: 'block' }} />
          )}
          {header.type === 'video' && (
            <video src={header.url} controls style={{ maxWidth: '100%', borderRadius: 8, display: 'block' }} />
          )}
          {header.type === 'document' && (
            <a href={header.url} target="_blank" rel="noreferrer" style={{ color: 'inherit', wordBreak: 'break-all' }}>📄 Documento</a>
          )}
        </div>
      )}

      {/* Cuerpo */}
      {text && <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{text}</div>}

      {/* Pie */}
      {footer && <div style={{ fontSize: '0.72rem', color: muted, fontStyle: 'italic', marginTop: 4 }}>{footer}</div>}

      {/* Botones de respuesta rápida */}
      {action.type === 'quick_reply' && (action.buttons || []).map((b, i) => (
        <div key={i} style={btnBox}>{b.title || b.text}</div>
      ))}

      {/* Botón de enlace (URL) */}
      {action.type === 'url' && (
        <a href={action.url} target="_blank" rel="noreferrer" style={{ ...btnBox, textDecoration: 'none' }}>
          🔗 {action.text}
        </a>
      )}

      {/* Lista de opciones */}
      {action.type === 'list' && (
        <div>
          <div style={btnBox}>≡ {action.buttonText}</div>
          {action.sectionTitle && (
            <div style={{ fontSize: '0.72rem', color: muted, fontWeight: 700, margin: '8px 0 2px' }}>{action.sectionTitle}</div>
          )}
          {(action.rows || []).map((r, i) => (
            <div key={i} style={{ borderTop: `1px solid ${line}`, padding: '6px 2px' }}>
              <div style={{ fontSize: '0.82rem', fontWeight: 600 }}>{r.title}</div>
              {r.description && <div style={{ fontSize: '0.74rem', color: muted }}>{r.description}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
